import React, { useState } from 'react'
import Form from '../../components/Form'
import { useForm } from 'react-hook-form'
import FormItem from '../../components/Form/FormItem'
import InputText from '../../components/Inputs/InputText'
import Dropdown from '../../components/Display/Dropdown'
import Select from '../../components/Inputs/Select'
import Button from '../../components/General/Button'
import Tooltip from '../../components/Display/Tooltip'
import axios from 'axios'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { Alert, Slide, SlideProps, Snackbar } from '@mui/material'

type TransitionProps = Omit<SlideProps, 'direction'>
const server = process.env.REACT_APP_SERVER_URL
const SubscriptionForm : React.FC<ISubscriptionForm> = ({onSubmit, subscriptionEnd, userPlan, name, subscriptionType, isLoading, onCancelSuscription, isLoadingCancel}) => {

    const paymentOptions = [{value: 'pagoMovil', text: 'Pago Móvil'}, {value: 'card', text: 'Tarjeta'}]

    const planesOptions = [{value: 'emprendedor', text: 'Emprendedor'}, {value: 'pyme', text: 'PYME'}, {value: 'corporativo', text: 'Corporativo'}]

    const periodOptions = [{value: 'MONTHLY', text: 'Mensual'}, {value: 'ANNUAL', text: 'Anual'}]

    const form = useForm({
        defaultValues: {
            name,
            subscriptionEnd,
            userPlan,
        }
      })

      const [transition, setTransition] = React.useState<
      React.ComponentType<TransitionProps> | undefined
    >(undefined)

    const [message, setMessage] = useState<string | null>(null)

    const [onShowMessage, setOnShowMessage] = useState<boolean>(false)

    const { addAlert } = useSnackBars()

    const getCurrentPlan = () => planesOptions.find(plan => plan.value === userPlan)

    const getCurrentPeriod = () => periodOptions.find(period => period.value === subscriptionType)

  const onSubmitForm = async (values) => {

    let response = await axios.post(`${server}/check-plan-users`, {plan: values.userPlan})
    
    if (!response.data.allowed) {

      let planQuantity = {
        emprendedor: 2,
        pyme: 5,
        corporativo: 12
      }

      setTransition(() => TransitionDown)

      setOnShowMessage(true)

      setMessage(`El plan al que deseas cambiar tiene un límite de ${planQuantity[values.userPlan]} usuarios. Debes eliminar usuarios para proceder.`)

      // addAlert({
      //   message: `El plan al que deseas cambiar tiene un límite de ${planQuantity[values.userPlan]} usuarios. Debes eliminar usuarios para proceder.`,
      //   status: 'error',
      // })

      return 
    }
    onSubmit(values)
  }

  function TransitionDown(props: TransitionProps) {
    return <Slide {...props} direction="down" />
  }

  return (
    <>
<Snackbar
        TransitionComponent={transition}
        open={onShowMessage}
        autoHideDuration={5000}
        onClose={() => {
          setOnShowMessage(false)
          setTimeout(() => {
            setMessage(null)
          }, 500)
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => {
            setOnShowMessage(false)
            setTimeout(() => {
              setMessage(null)
            }, 500)
          }}
          severity="error"
          sx={{ width: '100%' }}
        >
          {message}
        </Alert>
      </Snackbar>


      <Form
        form={form}
        classes={`  gap-y-2`}
        onSubmit={(values) => onSubmitForm(values)}
      >
        <div className="col-span-12" style={{fontWeight: 500, fontSize: 20}}>Suscripción</div>
        
        <FormItem name="name" classes="col-span-12">
          <InputText small label='Titular' disableInput />
        </FormItem>

        <FormItem name="paymentMethod" classes="col-span-12" defaultValue={paymentOptions[0]}>
          <Select label='Pagar con' options={paymentOptions} />
        </FormItem>

        <FormItem name="userPlan" classes="col-span-12" defaultValue={getCurrentPlan()}>
          <Select label='Plan actual' options={planesOptions} />
        </FormItem>

        <FormItem name="period" classes="col-span-12" defaultValue={getCurrentPeriod()}>
          <Select label='Periodo' options={periodOptions} />
        </FormItem>

        <FormItem name="subscriptionEnd" classes="col-span-12">
          <InputText label='Fecha de vencimiento' disableInput />
        </FormItem>

        <div className="col-span-12 mt-3">
        <Button type="primary" classes="w-full" htmlType="submit" loading={isLoading}>
          Realizar Pago
        </Button>
      </div>
      
      <div className="col-span-12 mt-3">
        <Tooltip title={"Solo para tarjeta internacional"}>
        <Button loading={isLoadingCancel} classes="w-full" onClick={() => {
        onCancelSuscription()
      }}>
        Cancelar suscripción
      </Button>
        </Tooltip>
     
      </div>
    </Form>
    </>
  )
}

export default SubscriptionForm

interface ISubscriptionForm {
    onSubmit: (v: any) => void;
    name: string;
    userPlan: string
    subscriptionEnd: string
    subscriptionType: string
    isLoading: boolean
    onCancelSuscription: () => void
    isLoadingCancel: boolean
}